import type { ReactNode } from 'react';
import type { AuditLogEntry } from '@core/api/auditLog';
import { AUDIT_ACTION_LABELS, AuditAction } from '@core/enum/auditAction';
import type { AuditLogRenderer } from '@core/utils/auditLog';
import { ENTITY_CRUD_RENDERERS } from './entityCrud';
import { renderEntityDuplicated } from './entityDuplicated';

export const AUDIT_LOG_RENDERERS: Partial<
  Record<AuditAction, AuditLogRenderer>
> = {
  ...ENTITY_CRUD_RENDERERS,
  [AuditAction.EntityDuplicated]: renderEntityDuplicated,
};

export function registerAuditLogRenderers(
  renderers: Partial<Record<AuditAction, AuditLogRenderer>>
): void {
  Object.assign(AUDIT_LOG_RENDERERS, renderers);
}

export function renderAuditLogSummary(entry: AuditLogEntry): ReactNode {
  const renderer = AUDIT_LOG_RENDERERS[entry.action];
  if (renderer) {
    return renderer(entry);
  }
  return AUDIT_ACTION_LABELS[entry.action] ?? entry.action;
}
